<template>
  <div class="pi-fco">
    <div class="pi-toolbar pi-fco__toolbar">
      <div class="pi-toolbar__field">
        <span><span id="pi-fco-min-label">Mínimo de elegíveis por empresa</span><pi-definition-tooltip class="pi-fco__info" info-key="features.minEligible"
                                                                                                    label="Mínimo de elegíveis por empresa"/></span>
        <div class="pi-toggle" role="group" aria-labelledby="pi-fco-min-label">
          <button v-for="option in view.minOptions" :key="option.value" type="button" class="pi-toggle__btn" :class="{ 'is-on': option.on }"
                  :aria-pressed="option.on ? 'true' : 'false'" :disabled="loading" @click="$emit('min-eligible', option.value)">{{ option.label }}</button>
        </div>
      </div>
      <filter-select class="pi-fco__journey" label="Jornada no fim da janela" :value="view.journey" :options="journeyOptions" all-label="Todas"
                     :disabled="loading" @input="$emit('journey', $event)">
        <pi-definition-tooltip slot="info" class="pi-fco__info" info-key="features.journeyAtEnd" label="Jornada no fim da janela"/>
      </filter-select>
    </div>

    <p v-if="view.notice" class="pi-notice" role="status">{{ view.notice }}</p>
    <p class="pi-muted pi-fco__line">{{ view.orderText }}</p>
    <p v-if="view.rankedText || view.belowText" class="pi-muted pi-fco__line">
      <strong v-if="view.rankedText" class="pi-fco__count">{{ view.rankedText }}.</strong>
      {{ view.belowText }}
    </p>
    <p v-if="view.sum.text" class="pi-fco__line pi-fco__sum" :class="'is-' + view.sum.tone">{{ view.sum.text }}</p>
    <p v-if="view.cutsText" class="pi-muted pi-fco__line">{{ view.cutsText }}</p>

    <framed-table v-if="view.rows.length || view.paging.total" :striped="false">
      <caption class="pi-sr">Empresas por % de adoção da funcionalidade nos 30 dias</caption>
      <thead>
      <tr>
        <template v-for="column in columns">
          <pi-sort-th v-if="column.sortable" :key="column.key" :column="column" :state="view.sortState" :disabled="loading" @sort="$emit('sort', $event)"/>
          <pi-th v-else :key="column.key" :column="column"/>
        </template>
      </tr>
      </thead>
      <tbody>
      <tr v-for="row in view.rows" :key="row.key">
        <td class="is-num pi-fco__rank">{{ row.rankText }}</td>
        <td>
          <pi-company-name :company-id="row.companyId" :shard-code="row.shardCode" :name="row.name" :query="view.query" :show-shard="false"/>
          <span v-if="row.factsText" class="pi-table__sub">{{ row.factsText }}</span>
        </td>
        <td class="is-num">
          <span class="pi-fco__adoption">
            <span v-if="row.barPct !== null" class="pi-fco__track" aria-hidden="true"><span class="pi-fco__fill" :style="{ width: row.barPct + '%' }"></span></span>
            <pi-metric-cell :cell="row.adoption" :show-ratio="false" :show-reason="false"/>
          </span>
          <span v-if="row.usersText" class="pi-table__sub">{{ row.usersText }}</span>
        </td>
        <td class="is-num">{{ row.adoptersText }}</td>
        <td class="is-num">{{ row.eligibleText }}</td>
        <td class="is-num" :title="view.roleTitle || null">
          {{ row.recurrenceText }}
          <span v-if="row.recurrenceShareText" class="pi-table__sub">{{ row.recurrenceShareText }}</span>
        </td>
        <td class="is-num" :title="view.roleTitle || null">{{ row.eventsText }}</td>
      </tr>
      </tbody>
      <table-pager slot="footer" :total="view.paging.total" :page="view.paging.page" :page-size="view.paging.pageSize" :disabled="loading"
                   @update:page="$emit('page', $event)" @update:pageSize="$emit('page-size', $event)"/>
    </framed-table>
    <p v-else class="pi-muted pi-fco__empty">{{ view.emptyText }}</p>
  </div>
</template>

<script>
import framedTable from "../default/framedTable.vue";
import tablePager from "../default/tablePager.vue";
import filterSelect from "../default/filterSelect.vue";
import piMetricCell from "./piMetricCell.vue";
import piSortTh from "./piSortTh.vue";
import piTh from "./piTh.vue";
import piCompanyName from "./piCompanyName.vue";
import piDefinitionTooltip from "./piDefinitionTooltip.vue";
import { screenColumns } from "./piColumns.js";
import { JOURNEY_OPTIONS } from "./piQuery.js";
import { COMPANY_ADOPTION_COLUMNS } from "./piFeatureCompaniesModel.js";

export default {
  name: "pi-feature-companies",
  components: { framedTable, tablePager, filterSelect, piMetricCell, piSortTh, piTh, piCompanyName, piDefinitionTooltip },
  props: {
    view: { type: Object, required: true },
    loading: { type: Boolean, default: false },
  },
  data() {
    return { columns: screenColumns(COMPANY_ADOPTION_COLUMNS), journeyOptions: JOURNEY_OPTIONS };
  },
};
</script>

<style src="./pi.css"></style>

<style scoped>
.pi-fco__toolbar .pi-toggle {
  align-self: flex-start;
}

.pi-fco__info {
  margin-left: 4px;
}

.pi-fco__line {
  margin: 0 0 6px;
}

.pi-fco__count {
  font-weight: 700;
  color: #3a424e;
}

.pi-fco__sum {
  font-size: 12px;
  color: #4e5560;
}

.pi-fco__sum.is-ok {
  color: #0f6b2b;
}

.pi-fco__sum.is-warn {
  color: #7a4f00;
  font-weight: 600;
}

.pi-fco__rank {
  width: 1%;
  color: #6b7280;
}

.pi-fco__adoption {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.pi-fco__track {
  display: inline-block;
  width: 56px;
  height: 6px;
  overflow: hidden;
  border-radius: 3px;
  background: #eceef1;
}

.pi-fco__fill {
  display: block;
  height: 100%;
  background: #1b59f8;
}

.pi-fco__empty {
  margin-top: 8px;
}

@media (max-width: 767px) {
  .pi-fco__track {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piFeatureCompanies.vue